import { yupResolver } from "@hookform/resolvers/yup";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { Button, Modal } from "src/components";
import { RootState } from "src/context/store";
import { useToast } from "src/hooks/useToast";
import { addCompany, editCompany } from "src/services/company-api";
import * as yup from "yup";
import GenericForm from "../counter-master/form.component";

interface IAddEditCompany {
  setShowAddForm: any;
  refetch: any;
}

//M10-9403
const schema = yup.object().shape({
  name: yup.string().required("Company Name is required"),
  shortcode: yup.string().required("Short Code is required"),
  shortname: yup
    .string()
    .required("Short Name is required")
    .test("no-spaces", "Short Name cannot contain spaces", (value) => !/\s/.test(value)), //M10-9403
  allow_placeOrder: yup.object().required("Allow Place Order is required"),
  // status: yup.object().required("Status is required")
});

const AddEditCompany = ({ setShowAddForm, refetch }: IAddEditCompany) => {
  const [loading, setLoading] = useState(false);

  const { toast } = useToast();

  const { addEditFormData, isEdit, priceIdentifier, userType } = useSelector((state: RootState) => state.company); //M10-9403
  const formFields: any[] = [
    {
      id: "name",
      type: "text",
      label: "Company Name",
      placeholder: "Enter Company Name",
      keyofForm: "name",
    },
    {
      id: "shortcode",
      type: "text",
      label: "Short Code",
      placeholder: "Enter Short Code",
      keyofForm: "shortcode",
    },
    {
      id: "shortname",
      type: "text",
      label: "Short Name",
      placeholder: "Enter Short Name",
      keyofForm: "shortname",
    },

    // {
    //   id: "status",
    //   type: "autocomplete",
    //   label: "Status",
    //   placeholder: "Enter Status",
    //   keyofForm: "status",
    //   suggestionList: [
    //     { value: true, label: "Active" },
    //     { value: false, label: "Inactive" },
    //   ],
    //   displayKey: "label",
    // },
    {
      id: "allow_placeOrder",
      type: "autocomplete",
      label: "Allow Place Order",
      placeholder: "Enter Allow Place Order",
      keyofForm: "allow_placeOrder",
      suggestionList: [
        { value: 1, label: "Yes" },
        { value: 0, label: "No" },
      ],
      displayKey: "label",
    },

    {
      id: "is_discount_display",
      type: "autocomplete",
      label: "Is Discount Display",
      placeholder: "Enter Is Discount Display",
      keyofForm: "is_discount_display",
      suggestionList: [
        { value: "Y", label: "Yes" },
        { value: "N", label: "No" },
      ],
      displayKey: "label",
    },
    {
      id: "ewaybill_applicable",
      type: "autocomplete",
      label: "E-Waybill Applicable",
      placeholder: "Enter Is E-Waybill Applicable",
      keyofForm: "ewaybill_applicable",
      suggestionList: [
        { value: "Y", label: "Yes" },
        { value: "N", label: "No" },
      ],
      displayKey: "label",
    },
    {
      id: "Price_Identifier_PO",
      type: "autocomplete",
      label: "Price Identifier PO",
      placeholder: "Enter Price Identifier PO",
      keyofForm: "Price_Identifier_PO",
      suggestionList: priceIdentifier,
      displayKey: "label",
    },
    {
      id: "einv_applicable",
      type: "autocomplete",
      label: "Einv Applicable",
      placeholder: "Enter Einv Applicable",
      keyofForm: "einv_applicable",
      suggestionList: [
        { value: "Y", label: "Yes" },
        { value: "N", label: "No" },
      ],
      displayKey: "label",
    },
    {
      label: "User Types",
      type: "multiselect",
      keyofForm: "usertypes",
      id: 12,
      display_key: "label",
      unique_key: "value",
      suggestionList: userType,
    },
    {
      id: "product_scheme_dropdown",
      type: "toggle",
      label: "Product Scheme Dropdown",
      placeholder: "Enter Product Scheme Dropdown",
      keyofForm: "product_scheme_dropdown",
      suggestionList: [
        { value: true, label: true },
        { value: false, label: false },
      ],
      displayKey: "label",
    },
    {
      id: "order_auto_approval_enabled",
      type: "toggle",
      label: "Order Auto Approval Enabled",
      placeholder: "Enter Order Auto Approval Enabled",
      keyofForm: "order_auto_approval_enabled",
      suggestionList: [
        { value: true, label: true },
        { value: false, label: false },
      ],
      displayKey: "label",
    },
    {
      id: "company_admin_approval_mo",
      type: "toggle",
      label: "Company Admin Approval MO",
      placeholder: "Enter Company Admin Approval MO",
      keyofForm: "company_admin_approval_mo",
      suggestionList: [
        { value: true, label: true },
        { value: false, label: false },
      ],
      displayKey: "label",
    },
  ]; //M10-9403

  const smartFormInstance = useForm({
    mode: "onBlur",
    defaultValues: structuredClone(
      isEdit
        ? structuredClone(addEditFormData)
        : {
            name: "",
            shortcode: "",
            shortname: "",
            allow_placeOrder: "",
            status: true, //M10-9403
            is_discount_display: "",
            // Price_Identifier_PO: "",
            einv_applicable: "",
            product_scheme_dropdown: false,
            order_auto_approval_enabled: false,
            company_admin_approval_mo: false, //M10-9403
            highest_position: null,
            lowest_position: null,
          }
    ),
    resolver: yupResolver(schema) as any,
  });

  const autocompleteHandler = (_: any, key?: string) => {
    // highest position should always be greater then lowest position
    if (key === "highest_position") {
      smartFormInstance.setValue("lowest_position", null);
    }
  };

  const onSubmit = async (data: any) => {
    if (loading) return;
    try {
      const payload = {
        ...data,
        shortname: data?.shortname?.replace(/\s+/g, ""), // M10-9403
        status: true, //M10-9403
        allow_placeOrder: data?.allow_placeOrder?.value,
        Price_Identifier_PO: data?.Price_Identifier_PO?.value || 100,
        einv_applicable: data?.einv_applicable?.value,
        is_discount_display: data?.is_discount_display?.value,
        ewaybill_applicable: data?.ewaybill_applicable?.value,
      };
      //M10-9403
      if (isEdit) {
        payload.uid = addEditFormData.uid;
      }
      const res = isEdit ? await editCompany(payload, addEditFormData.code) : await addCompany(payload);
      if (res.status === 200) {
        toast({
          title: "Success",
          description: isEdit ? "Company edited successfully" : "Company added successfully", //M10-9403
          variant: "default",
        });
        setTimeout(() => {
          refetch();
          setShowAddForm(false);
        }, 1000);
      }
    } catch (error) {
      console.error(error);
      toast({
        title: "Error",
        description: "Something went wrong",
        variant: "destructive",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      isHeader={true}
      onBack={() => {
        setShowAddForm(false);
      }}
      title={isEdit ? "Edit Company" : "Select Company"}
      isOpen={true}
      onCloseModal={() => {
        setShowAddForm(false);
      }}
    >
      <GenericForm
        onAutocompleteChange={autocompleteHandler}
        formFields={formFields}
        onFormSubmit={() => {}}
        defaultValues={{}}
        formInstance={smartFormInstance}
      >
        <footer className="flex justify-end gap-3 px-5 pb-5">
          <Button onClick={() => setShowAddForm(false)} className="border">
            Cancel
          </Button>
          <Button
            isLoading={loading}
            loaderSize="small"
            disabled={loading}
            onClick={() => {
              setLoading(true);
              smartFormInstance.handleSubmit(onSubmit, () => {
                setLoading(false);
              })();
            }}
            className="text-white bg-primary"
          >
            {isEdit ? "Edit" : "Add"}
            Company
          </Button>
        </footer>
      </GenericForm>
    </Modal>
  );
};

export default AddEditCompany;
